// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\npre[data-v-36c7f018]{\n\tbackground: #fff;\n\tmax-width: 80mm;\n\tpadding: 15px;\n\tfont-family: sans-serif;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
